export interface MarkerColor {
  readonly color: string;
  readonly backgroundColor: string;
}

// Generate a js array of pair of colors. Must be  unique, distinct, mild color blindness safe. 32 entries. each must consists of a foreground & background color that an in high contrast. no whitish backgrounds. output: `[{color: "...", backgroundColor:"..."}]`

const colors: MarkerColor[] = [
  { color: "#ffffff", backgroundColor: "#440154" },
  { color: "#f8f9fa", backgroundColor: "#481a6c" },
  { color: "#e9ecef", backgroundColor: "#472f7d" },
  { color: "#dee2e6", backgroundColor: "#414487" },
  { color: "#ced4da", backgroundColor: "#39568c" },
  { color: "#adb5bd", backgroundColor: "#31688e" },
  { color: "#ffffff", backgroundColor: "#2a788e" },
  { color: "#ffffff", backgroundColor: "#23888e" },
  { color: "#ffffff", backgroundColor: "#1f988b" },
  { color: "#f8f9fa", backgroundColor: "#22a884" },
  { color: "#000000", backgroundColor: "#35b779" },
  { color: "#000000", backgroundColor: "#54c568" },
  { color: "#000000", backgroundColor: "#7ad151" },
  { color: "#000000", backgroundColor: "#a5db36" },
  { color: "#000000", backgroundColor: "#d2e21b" },
  { color: "#000000", backgroundColor: "#fde725" },
  { color: "#ffffff", backgroundColor: "#0d0887" },
  { color: "#f8f9fa", backgroundColor: "#330597" },
  { color: "#e9ecef", backgroundColor: "#5002a2" },
  { color: "#dee2e6", backgroundColor: "#6a00a8" },
  { color: "#ced4da", backgroundColor: "#8405a7" },
  { color: "#adb5bd", backgroundColor: "#9c179e" },
  { color: "#ffffff", backgroundColor: "#b12a90" },
  { color: "#ffffff", backgroundColor: "#c33d80" },
  { color: "#ffffff", backgroundColor: "#d35171" },
  { color: "#000000", backgroundColor: "#e16462" },
  { color: "#000000", backgroundColor: "#ed7953" },
  { color: "#000000", backgroundColor: "#f68f44" },
  { color: "#000000", backgroundColor: "#fca636" },
  { color: "#000000", backgroundColor: "#fec029" },
  { color: "#000000", backgroundColor: "#f9dc24" },
  { color: "#000000", backgroundColor: "#f0f921" },
];

function stringHash(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash) >>> 0; // Unsigned 32-bit
}

/** Picks a palette color deterministically from the given key, so the same key always gets the same color. */
export function colorForKey(key: string): MarkerColor {
  return colors[stringHash(key) % colors.length];
}
